
import React from 'react';
import { Card } from '../ui/card';
import { Shield, MessageCircle, DollarSign, Search, CheckCircle } from 'lucide-react';

const ProblemsSection: React.FC = () => {
  const problems = [
    {
      problem: "Endless Scrolling",
      solution: "Smart Matching",
      problemIcon: <Search className="w-12 h-12 text-red-400" />,
      solutionIcon: <CheckCircle className="w-12 h-12 text-green-400" />,
      description: "Stop scrolling through hundreds of irrelevant listings"
    },
    {
      problem: "Rental Scams",
      solution: "Verified Only",
      problemIcon: <Shield className="w-12 h-12 text-red-400" />,
      solutionIcon: <CheckCircle className="w-12 h-12 text-green-400" />,
      description: "Every listing verified. Zero fake properties."
    },
    {
      problem: "No Response",
      solution: "Direct Connect",
      problemIcon: <MessageCircle className="w-12 h-12 text-red-400" />,
      solutionIcon: <CheckCircle className="w-12 h-12 text-green-400" />,
      description: "Instant communication with real landlords"
    },
    {
      problem: "Hidden Fees",
      solution: "No Broker Fees",
      problemIcon: <DollarSign className="w-12 h-12 text-red-400" />,
      solutionIcon: <CheckCircle className="w-12 h-12 text-green-400" />,
      description: "Connect directly. No middleman. No extra costs."
    }
  ];

  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900"></div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 animate-fade-in-subtle">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Renting Problems, <span className="text-pink-400">Solved</span>
          </h2>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {problems.map((item, index) => (
            <Card 
              key={index} 
              className="bg-slate-800/50 backdrop-blur-xl border border-slate-700/50 p-8 hover:shadow-2xl transition-all duration-500 hover:scale-105 transform hover:-translate-y-1 animate-fade-in-stagger relative overflow-hidden group"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              {/* Problem State */}
              <div className="group-hover:opacity-0 transition-opacity duration-300">
                <div className="mb-6 flex justify-center transform transition-transform duration-300">
                  {item.problemIcon}
                </div>
                <h3 className="text-xl font-bold text-red-400 mb-2 text-center">{item.problem}</h3>
                <div className="w-full h-1 bg-red-400/20 rounded-full">
                  <div className="w-full h-1 bg-red-400 rounded-full"></div>
                </div>
              </div>

              {/* Solution State */}
              <div className="absolute inset-0 p-8 flex flex-col justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-slate-800/90 backdrop-blur-xl">
                <div className="mb-6 flex justify-center transform transition-transform duration-300">
                  {item.solutionIcon}
                </div>
                <h3 className="text-xl font-bold text-green-400 mb-4 text-center">{item.solution}</h3>
                <p className="text-slate-300 text-center text-sm leading-relaxed">{item.description}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProblemsSection;
